module.exports = __webpack_public_path__ + "img/9788934985808.f8670058.jpg";